import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=b34b4e72&scoped=true"
import script from "./RequestCard.vue?vue&type=script&lang=js"
export * from "./RequestCard.vue?vue&type=script&lang=js"
import style0 from "./RequestCard.vue?vue&type=style&index=0&id=b34b4e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34b4e72",
  null
  
)

export default component.exports